module.exports = __webpack_public_path__ + "static/media/directions_zh@3x.12aec80e.png";